export const INVENTORY_TYPE = {
  FLOWER: 'FLOWER',
  CARTRIDGE: 'CARTRIDGE',
  EXTRACT: 'EXTRACT',
  EDIBLE: 'EDIBLE',
  MISC: 'MISC',
  MERCH: 'MERCH',
  PREROLL: 'PREROLL',
  TOPICAL: 'TOPICAL',
  PLANT: 'PLANT',
  MORE: 'MORE',
  ALL: 'ALL',
  PILL: 'PILL',
  BEVERAGE: 'BEVERAGE',
  CBD: 'CBD',
  TINCTURE: 'TINCTURE',
};



// WEBPACK FOOTER //
// ./src/const/inventory_types.js